var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-menu"},[_c('div',{staticClass:"left-menu-li"},_vm._l((_vm.routerPath.children),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"left-menu-title"},[_vm._v(_vm._s(item.meta.title))]),_vm._l((item.children),function(items,indexs){return _c('div',{key:indexs,staticClass:"left-menu-list"},[(!items.hidden)?_c('router-link',{class:[
            'left-menu-item',
            index == _vm.indexActive[0] && indexs == _vm.indexActive[1]
              ? 'menu-active'
              : '' ],attrs:{"to":{
            path: '/' + _vm.routerPath.path + '/' + item.path + '/' + items.path,
          }}},[_vm._v(" "+_vm._s(items.meta.title)+" ")]):_vm._e()],1)})],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }